<div class="page-container" *ngIf="hasAccess">
  <div *ngIf="!stepOneComplete">
    <mat-card class="main-container mat-elevation-z2" style="padding: 20px">
      <mat-card-title>
        <div class="card-header-flex">
          <span class="card-title">Agency Application Form</span>
          <div class="header-right-side">
            <div class="agency-id-pill">
              Agency ID <span class="agency-id-value">{{ agencyId }}</span>
            </div>
            <span class="legacyId" *ngIf="oldAgencyId != null"
              >Legacy ID: {{ oldAgencyId }}</span
            >
          </div>
        </div>
      </mat-card-title>
      <mat-card-content>
        <div class="document-instructions">
          <div class="warning-alert-box">
            <mat-icon class="warning-icon">warning_amber</mat-icon>
            <div class="warning-text">
              <span class="bold-red-text">Before starting,</span>
              please ensure that you have <strong>PDFs</strong> of the following documents ready to upload in your application
            </div>
          </div>

          <div class="required-docs-label">REQUIRED DOCUMENTS</div>

          <div class="onboarding-list">
            <div class="onboarding-item">
              <div class="onboarding-badge">1</div>
              <div class="onboarding-content">
                <span class="item-title">ICEF Accreditation Certificate</span>
                <span class="item-or"> or </span>
                <span class="item-title">Two Reference Letters</span>
                <ul class="onboarding-sub-bullets">
                  <li class="sub-bullet-green">
                    <strong>If you are ICEF accredited</strong> — upload a blank PDF in both "Reference 1" & "Reference 2". Seneca will verify your accreditation directly via
                    <a href="https://www.icef.com/ias-directory/" target="_blank">icef.com/ias-directory</a>.
                  </li>
                  <li class="sub-bullet-orange">
                    <strong>If you are not ICEF accredited</strong> — upload two reference letters, preferably from educational institutions you have successfully sent students to. Note: Seneca does not contact references on your behalf.
                  </li>
                </ul>
              </div>
            </div>

            <div class="onboarding-item">
              <div class="onboarding-badge">2</div>
              <div class="onboarding-content">
                <span class="item-title">Business Plan</span>
              </div>
            </div>

            <div class="onboarding-item">
              <div class="onboarding-badge">3</div>
              <div class="onboarding-content">
                <span class="item-title">Owner's Resume</span>
              </div>
            </div>

            <div class="onboarding-item">
              <div class="onboarding-badge">4</div>
              <div class="onboarding-content">
                <span class="item-title">Company Profile</span>
              </div>
            </div>

            <div class="onboarding-item">
              <div class="onboarding-badge">5</div>
              <div class="onboarding-content">
                <span class="item-title">Copy of Registered Business License</span>
              </div>
            </div>
          </div>

          <div class="onboarding-footer-divider"></div>
          <p class="onboarding-footer-text">
            Please complete and save each section. Fields marked <span class="mandatory-star">*</span> are mandatory. <strong>At least one signing officer must be provided.</strong> Thank you.
          </p>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-accordion class="onboarding-form-accordion">
      <!-- <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Agent Agreement, Renewal & Certificate
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-my-profile-agreement></app-my-profile-agreement>
      </mat-expansion-panel> -->

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Contact Information </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngFor="let form of contactInfoForms; let i = index">
          <app-onboarding-contact-information
            [formId]="form"
            [formIndex]="i"
            [agencyId]="agencyId"
            [agentId]="agentId"
            [contactInfoStatus]="contactInfoStatus"
            (saveContactInfo)="saveContactInfo($event)"
          ></app-onboarding-contact-information>
          <hr *ngIf="i < contactInfoForms.length - 1" />
        </div>
        <button
          mat-stroked-button
          color="primary"
          class="add-contact-button"
          (click)="addContactInfoForm()">
          <mat-icon>add</mat-icon>
          <span>Add Another Contact</span>
        </button>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Business Entity Information </mat-panel-title>
        </mat-expansion-panel-header>
        <app-onboarding-company-information
          [agencyId]="agencyId"
          [agentId]="agentId"
          [businessInfoStatus]="businessInfoStatus"
          (saveCompanyInfo)="saveCompanyInfo($event)"
        ></app-onboarding-company-information>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Mandatory Documents </mat-panel-title>
        </mat-expansion-panel-header>
        <app-onboarding-mandatory-documents
          [agencyId]="agencyId"
          [ContactInfo]="ContactInfo"
          [CompanyInfo]="CompanyInfo"
        ></app-onboarding-mandatory-documents>
      </mat-expansion-panel>

      <!-- 
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Financial Information </mat-panel-title>
        </mat-expansion-panel-header>
        <app-financial-information
          [agencyId]="agencyId"
          *ngIf="!isLoading"
        ></app-financial-information>
      </mat-expansion-panel> -->

      <!-- <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Agent Training
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-agent-training></app-agent-training>
      </mat-expansion-panel> -->
    </mat-accordion>
  </div>
  <div *ngIf="stepOneComplete && !stepTwoComplete">
    <mat-card class="main-container mat-elevation-z2" style="padding: 20px">
      <mat-card-title>
        <div class="card-header-flex">
          <span class="card-title">Agency Application Form - Step 2</span>
          <div class="header-right-side">
            <div class="agency-id-pill">
              Agency ID <span class="agency-id-value">{{ agencyId }}</span>
            </div>
            <span class="legacyId" *ngIf="oldAgencyId != null"
              >Legacy ID: {{ oldAgencyId }}</span
            >
          </div>
        </div>
      </mat-card-title>
      <mat-card-content>
        <div class="document-instructions" style="width: 100%;">
          <div class="onboarding-list">
            <div class="onboarding-item">
              <div class="onboarding-badge">1</div>
              <div class="onboarding-content">
                <span class="item-title">Quiz</span>
                <p class="step2-instruction-text">
                  You must complete and submit the agent quiz before proceeding with financial information. The quiz can be completed at the following link:
                </p>
                <div class="step2-quiz-link-wrapper">
                  <a href="https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=Svc06-dYi0qeWUM-TEEnV4elGFab3UxMgiUGGCVs3wFUMUo2VEIzVUkxOVZZTjdEVkEzRlVIQ1Y0TC4u" target="_blank" class="step2-quiz-link">
                    International Agency Onboarding Quiz
                    <mat-icon class="step2-link-icon">open_in_new</mat-icon>
                  </a>
                  <span class="step2-link-note">(The link will open in a new Tab)</span>
                </div>
              </div>
            </div>

            <div class="onboarding-item">
              <div class="onboarding-badge">2</div>
              <div class="onboarding-content">
                <span class="item-title">Financial Information</span>
                <p class="step2-instruction-text step2-paragraph-spacing">
                  For payment setup, choose <strong>only one</strong> of the following options:
                </p>
                <ul class="onboarding-sub-bullets">
                  <li class="sub-bullet-black">
                    Direct Deposit (recommended for US/Canada based agencies)
                  </li>
                  <li class="sub-bullet-black">
                    Wire Transfer (recommended for international agencies)
                  </li>
                </ul>
                <div class="step2-info-alert">
                  <mat-icon class="step2-info-icon">info</mat-icon>
                  <span>Please ensure all information provided is accurate to avoid payment delays.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <br />

    <!-- Payment Method Selection -->
    <mat-card class="main-container mat-elevation-z2 financial-method-card">
      <mat-card-title>
        <span class="card-title financial-method-title">Financial Information</span>
      </mat-card-title>
      <mat-card-content>
        <mat-radio-group
          class="financial-method-options"
          [(ngModel)]="selectedPaymentMethod"
          aria-label="Payment Method"
        >
          <mat-radio-button value="D" color="primary">
            <strong>Direct Deposit</strong>
            <div style="font-size: 12px; color: #666; margin-top: 2px;">Recommended for US/Canada based agencies</div>
          </mat-radio-button>
          <mat-radio-button value="W" color="primary">
            <strong>Wire Transfer</strong>
            <div style="font-size: 12px; color: #666; margin-top: 2px;">Recommended for international agencies</div>
          </mat-radio-button>
        </mat-radio-group>
      </mat-card-content>
    </mat-card>

    <br />

    <mat-accordion class="onboarding-form-accordion financial-form-accordion">
    <!-- Direct Deposit Form -->
    <mat-expansion-panel *ngIf="selectedPaymentMethod === 'D'" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Financial Information - Direct Deposit
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-direct-deposit [agencyId]="agencyId" [paymentMethod]="selectedPaymentMethod" (submitted)="onFinancialInfoSubmitted()"></app-direct-deposit>
    </mat-expansion-panel>

    <!-- Wire Transfer Form -->
    <mat-expansion-panel *ngIf="selectedPaymentMethod === 'W'" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Financial Information - Wire Transfer
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-wire-transfer [agencyId]="agencyId" [paymentMethod]="selectedPaymentMethod" (submitted)="onFinancialInfoSubmitted()"></app-wire-transfer>
    </mat-expansion-panel>
    </mat-accordion>

  </div>

  <div *ngIf="stepOneComplete && stepTwoComplete">
    <mat-card class="mat-elevation-z2" style="padding: 60px 40px; text-align: center; max-width: 680px; margin: 40px auto; display: block; box-sizing: border-box; height: auto; min-height: fit-content;">
      <mat-card-content style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%;">
        <mat-icon style="font-size: 72px; height: 72px; width: 72px; line-height: 72px; overflow: visible; color: #4caf50; display: block; margin: 0 auto 30px;">check_circle</mat-icon>
        <h2 style="font-size: 26px; font-weight: 600; color: #1a1a1a; margin: 0 0 20px; display: block; width: 100%;">Application Submitted</h2>
        <p style="font-size: 16px; color: #555; line-height: 1.75; margin: 0 auto; max-width: 480px; display: block; width: 100%;">
          Thank you for completing the application. Your submission has been received and is currently being reviewed by our team.
          We will be in touch if any additional information is required.
        </p>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<ng-template [ngIf]="!hasAccess">
  <div class="page-container">
    <mat-card class="main-container mat-elevation-z2">
      <mat-card-content>
        <h1>You do not have access to this page</h1>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>

<!-- DEBUG PANEL -->
<!-- <div style="position: fixed; bottom: 20px; right: 20px; width: 400px; max-height: 600px; background: #f5f5f5; border: 2px solid #333; padding: 15px; border-radius: 8px; overflow-y: auto; z-index: 9999; font-family: monospace; font-size: 11px;">
  <div style="font-weight: bold; margin-bottom: 10px; cursor: pointer; background: #333; color: white; padding: 5px;">
    📊 DEBUG DATA
  </div>
  <div style="margin-bottom: 10px;">
    <strong>ContactInfo Array ({{ ContactInfo?.length || 0 }} forms):</strong>
    <pre style="background: white; padding: 5px; border-radius: 4px; overflow-x: auto;">{{ ContactInfo | json }}</pre>
  </div>
  <div style="margin-bottom: 10px;">
    <strong>CompanyInfo:</strong>
    <pre style="background: white; padding: 5px; border-radius: 4px; overflow-x: auto;">{{ CompanyInfo | json }}</pre>
  </div>
  <div style="margin-bottom: 10px;">
    <strong>AgencyId:</strong>
    <pre style="background: white; padding: 5px; border-radius: 4px;">{{ agencyId }}</pre>
  </div>
  <div style="margin-bottom: 10px;">
    <strong>AgentId:</strong>
    <pre style="background: white; padding: 5px; border-radius: 4px;">{{ agentId }}</pre>
  </div>
</div> -->
